import { Map as immutableMap } from 'immutable';
import { getField, updateField } from 'vuex-map-fields';

const STATE = immutableMap({
  date: Date.now(),
  showJSON: false,
});

export const state = () => STATE.toJS();

export const getters = {
  getField,
};

export const mutations = {
  reset(state) {
    Object.assign(state, {
      ...STATE.toJS(),
      date: Date.now(),
    });
  },
  updateField,
};

export const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
